const services = [
  {
    icon: "ri-file-list-3-line",
    title: "Revisión de facturas",
    description:
      "Analizamos tus facturas de luz y gas en detalle para detectar cobros incorrectos, conceptos mal aplicados y oportunidades de mejora inmediata.",
  },
  {
    icon: "ri-contract-line",
    title: "Optimización de contratos",
    description:
      "Revisamos los términos de tu contrato actual y negociamos con las comercializadoras para obtener las mejores condiciones adaptadas a tu perfil.",
  },
  {
    icon: "ri-user-settings-line",
    title: "Asesoramiento personalizado",
    description:
      "Cada cliente es diferente. Analizamos tu situación específica y te damos recomendaciones concretas, no soluciones genéricas.",
  },
  {
    icon: "ri-dashboard-line",
    title: "Revisión de potencia",
    description:
      "Ajustamos la potencia contratada a tu consumo real. Muchos clientes pagan más de lo necesario por tener una potencia sobredimensionada.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Comparación de suministros",
    description:
      "Comparamos opciones del mercado libre y regulado para encontrar la tarifa que mejor se adapta a tus necesidades y perfil de consumo.",
  },
  {
    icon: "ri-sun-line",
    title: "Autoconsumo solar",
    description:
      "Te asesoramos sobre instalaciones fotovoltaicas, retorno de inversión, trámites, subvenciones y la mejor forma de rentabilizar la energía solar.",
  },

  {
    icon: "ri-store-3-line",
    title: "PPA Onsite – Solar sin inversión",
    description:
      "Instalación de paneles solares en tu cubierta sin pagar nada por adelantado. Comparamos las mejores ofertas del mercado, negociamos en tu nombre y tú solo pagas por la energía que consumes, a un precio inferior al de la red. Ideal para pymes, naves y negocios con consumo medio-alto.",
  },
  {
    icon: "ri-cpu-line",
    title: "Contador inteligente en propiedad",
    description:
      "¿Sabías que pagas un alquiler mensual por tu contador? Te ayudamos a sustituirlo por uno propio con telegestión: consume en tiempo real, detecta anomalías y toma decisiones con datos reales. Se amortiza en pocos meses solo con lo que dejas de pagar en alquiler.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Reclamaciones ante distribuidoras",
    description:
      "¿Te han cobrado de más? ¿Tu distribuidora no responde? Gestionamos tu reclamación de principio a fin: revisamos la facturación, identificamos errores, preparamos la documentación y hacemos seguimiento hasta la resolución. Sin tecnicismos, sin que pierdas tiempo.",
  },
];

export default function Services() {
  const handleScroll = () => {
    const el = document.querySelector("#contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="servicios" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-faro-teal text-sm font-semibold uppercase tracking-widest">
            Nuestros servicios
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-faro-navy mt-3 mb-4">
            Todo lo que necesitas para pagar lo justo
          </h2>
          <p className="text-faro-gray-text text-lg max-w-2xl mx-auto">
            Ofrecemos un servicio completo de consultoría energética. Desde la revisión de tu primera factura hasta la instalación de paneles solares.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {services.map((service) => (
            <div
              key={service.title}
              className="group p-6 rounded-xl border border-faro-gray-mid hover:border-faro-teal/40 hover:bg-faro-teal-pale/30 transition-all duration-300 cursor-default"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-faro-navy/5 group-hover:bg-faro-teal/10 rounded-lg mb-4 transition-colors duration-300">
                <i className={`${service.icon} text-faro-navy group-hover:text-faro-teal text-lg transition-colors duration-300`} />
              </div>
              <h3 className="text-faro-navy font-semibold text-base mb-2">
                {service.title}
              </h3>
              <p className="text-faro-gray-text text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={handleScroll}
            className="bg-faro-navy hover:bg-faro-navy-light text-white font-semibold text-sm px-8 py-3.5 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Solicita una consulta gratuita
          </button>
        </div>
      </div>
    </section>
  );
}
